<template>
  <v-select
    ref="input"
    v-model="selected"
    :items="items"
    autocomplete
    chips
    deletable-chips
    item-text="name"
    item-value="id"
    multiple
    return-object
    v-bind="$attrs"
    append-icon=""
    @blur="add"
    @keydown.enter.native="add"
    @update:searchInput="fetchContacts"
  />
</template>

<script>
import Api from '~/store/idonia-api/api.js'
import { debounce } from 'lodash'

export default {
  name: 'ContactsInput',
  props: {
    initialSelected: {
      type: Array,
      default: () => []
    }
  },
  created () {
    this.$validator.attach({ name: 'email', rules: 'required|email' })
  },
  data () {
    return {
      selected: this.initialSelected,
      items: this.initialSelected
    }
  },
  watch: {
    selected (newValue) {
      this.$refs.input.lazySearch = ''
      this.items = this.selected

      this.$emit('input', newValue)
    }
  },
  methods: {
    fetchContacts: debounce(async function (e) {
      if (!e || e.trim() === '') {
        return
      }
      const { data } = await Api.getV2('account-contacts', { match: e })
      if (data) {
        this.items = [
          ...this.items,
          ...data.map(item => {
            return { id: item.actor_id, name: item.name, type: 'account' }
          })
        ]
      }
    }, 700),
    async add (e) {
      if (typeof e !== 'undefined') {
        const value = e.target.value
        const valid = await this.$validator.validate('email', value)

        if (valid) {
          const mappedItem = { id: Date.now(), name: value, type: 'guest' }
          this.items.push(mappedItem)
          this.selected.push(mappedItem)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/account/ContactsInput.vue